import type { IconData } from '@stacksjs/iconify-core'

export const tableCell: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 6h4V2H2zm0 2v4h4V8zm10-2V2H8v4zm0 2H8v4h4zM2 0h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export default tableCell
